import request from "./request";

// 活动
export function getActivity() {
  return request({
    url: "/gsweb/content/index",
    method: "get",
  });
}

// 协议
export function agreementList(data) {
  return request(
    {
      url: "/gsweb/sys/agreement",
      method: "post",
      data,
    },
    false
  );
}

// 域名后缀(二级)
export function getDomainSuffix() {
  return request({
    url: "/gsweb/domain/domainSuffix",
    method: "get",
  });
}

// 获取敏感词
export function sensitiveWords() {
  return request(
    {
      url: "/gsweb/domain/sensitiveWords",
      method: "post",
    },
    false
  );
}

// 域名注册查询
export function searchDomain(data) {
  return request(
    {
      url: "/gsweb/domain/check",
      method: "post",
      data,
    },
    true
  );
}

//域名价格
export function getPriceList(type) {
  return request(
    {
      url: "/gsweb/domain/domainPrice/" + type,
      method: "get",
      isToken: false,
    },

  );
}

//加入购物车
export function addShopCart(data) {
  return request({
	url: "/gsweb/cart/save",
    data,
    method: "post",
    isToken: true,
  });
}

// 查询模板
export function getTemplates(params) {
  return request({
    url: "/gsweb/domain/templates/list",
    params,
    method: "get",
    isToken: true,
  });
}

// 购物车查询
export function getShoppingCart(params) {
  return request({
    url: "/gsweb/cart/getList",
    params,
    method: "get",
    isToken: true,
  });
}

// 修改年限
export function orderCountEdit(data) {
  return request({
    url: "/gsweb/cart/year",
    data,
    method: "post",
    isToken: true,
  });
}

// 购物车删除
export function delectShopCart(data) {
  return request({
    url: "/gsweb/cart/delete",
    data,
    method: "DELETE",
    isToken: true,
  });
}

// 模板删除
export function delectTemplates(templateId) {
  return request({
    url: `/gsweb/domain/templates/delete/${templateId}`,
    method: "DELETE",
    isToken: true,
  });
}

// 创建订单
export function createOrder(data) {
  return request({
    url: "/gsweb/cart/order/save",
    data,
    method: "post",
    isToken: true,
  });
}

// 支付订单
export function pay(data) {
  return request({
    url: "/gsweb/pay",
    data,
    method: "post",
    isToken: true,
  });
}

// 获取支付订单
export function orderPayOrder(params) {
  return request({
    url: "/gsweb/order/pay/get",
    params,
    method: "get",
    isToken: true,
  });
}

// 域名查询条件
export function domainQuery() {
  return request({
    url: "/gsweb/domain/getCondition",
    method: "get",
    isToken: true,
  });
}

// 域名品类
export function domainTypeList() {
  return request({
    url: "/gsweb/domain/domainStructure",
    method: "get",
    isToken: true,
  });
}

// 我的域名
export function domainList(params) {
  return request({
    url: "/gsweb/domain/myDomain",
    params,
    method: "get",
    isToken: true,
  });
}

// 我的模板
export function templatesList(params) {
  return request({
    url: "/gsweb/domain/templates/list",
    params,
    method: "get",
    isToken: true,
  });
}

// 我的模板-根据模板查看域名列表
export function templatesDomainList(params) {
  return request({
    url: "/gsweb/domain/templates/one",
    params,
    method: "get",
    isToken: true,
  });
}

// 删除模板
export function deleteTemplate(params) {
  return request({
    method: "delete",
    url: `/gsweb/domain/templates/delete/${params}`,
    isToken: true,
  });
}

// 复制模板
export function getTemplateCopy(params) {
  return request({
    url: "/gsweb/domain/templates/copy",
    params,
    method: "get",
    isToken: true,
  });
}

// 获取邮箱，企业，个人认证
export function getcertifiedInformation() {
  return request({
    url: "/gsweb/approve/verifyInfo",
    method: "get",
    isToken: true,
  });
}

// 获取中国地区城市
export function getRegionList() {
  return request({
    url: "/gsweb/client/area",
    method: "get",
    isToken: true,
  });
}

// 查询默认模板
export function getTemplatesDefault() {
  return request({
    url: "/gsweb/domain/templates/default/info",
    method: "get",
    isToken: true,
  });
}

// 提交模板
export function templatesSave(data) {
  return request({
    url: "/gsweb/domain/templates/add",
    data, // post
    method: "post",
    isToken: true,
  });
}

// 提交默认模板
export function templatesDefaultSave(data) {
  return request({
    url: "/gsweb/domain/templates/default/save",
    params: data, // post query参数
    method: "post",
    isToken: true,
  });
}

// 模板过户
export function templatesTransfer(data) {
  return request({
    url: "/gsweb/domain/templates/push",
    data,
    method: "post",
    isToken: true,
  });
}

// 模板过户记录
export function getTemplatesTransferList(params) {
  return request({
    url: "/gsweb/domain/templates/pushList",
    params,
    method: "get",
    isToken: true,
  });
}

// 转出记录
export function getTransferOutList(params) {
  return request({
    url: "/gsweb/domain/transferOut/list",
    params,
    method: "get",
    isToken: true,
  });
}

// 转出-重新索取转移码
export function transferOutRefreshCode(params) {
  return request({
    url: "/gsweb/domain/transferOut/code/new",
    params,
    method: "post",
    isToken: true,
  });
}

// 转出-取消转出
export function transferOutCancel(params) {
  return request({
    url: "/gsweb/domain/transferOut/cancel",
    params,
    method: "DELETE",
    isToken: true,
  });
}

// 转出-同意转出
export function transferOutConsent(params) {
  return request({
    url: "/gsweb/domain/transferOut/agree",
    params,
    method: "post",
    isToken: true,
  });
}

// 转出-查询状态
export function transferOutQueryStatus(params) {
  return request({
    url: "/gsweb/domain/transferOut/status",
    params,
    method: "get",
    isToken: true,
  });
}

// 转入记录
export function transferIntoList(params) {
  return request({
    url: "/gsweb/domain/transferInto/list",
    params,
    method: "get",
    isToken: true,
  });
}

// 转入-修改转移码
export function transferIntoEdit(params) {
  return request({
    url: "/gsweb/domain/transferInto/code/update",
    params,
    method: "post",
    isToken: true,
  });
}

// 转入-查询状态
export function transferIntoDetail(params) {
  return request({
    url: "/gsweb/domain/transferInto/status",
    params,
    method: "get",
    isToken: true,
  });
}

// 转出-检测域名
export function transferOutCheckDomain(params) {
  return request({
    url: "/gsweb/domain/transferOut/verify/domain",
    params,
    method: "get",
    isToken: true,
  });
}

// 转出-检测手机
export function transferOutCheckMobile(data) {
  return request({
    url: "/gsweb/domain/transferOut/verify/code",
    data,
    method: "post",
    isToken: true,
  });
}

// 转出-获取转移码
export function transferOutTransferCode(data) {
  return request({
    url: "/gsweb/domain/transferOut/getTransferCode",
    params: data, // post query参数
    method: "post",
    isToken: true,
  });
}

// 转入-保存
export function transferIntoSave(data) {
  return request({
    url: "/gsweb/domain/transferInto/add",
    data,
    method: "post",
    isToken: true,
  });
}

// PUSH-检测用户是否存在
export function userCheck(params) {
  return request({
    url: "/gsweb/client/check",
    params,
    method: "get",
    isToken: true,
  });
}

// PUSH
export function pushCreate(data) {
  return request({
    url: "/gsweb/domain/push/add",
    data,
    method: "post",
    isToken: true,
  });
}

// PUSH-分页查询
export function pushPageList(params) {
  return request({
    url: "/gsweb/domain/push/list",
    params,
    method: "get",
    isToken: true,
  });
}

// PUSH-操作
export function pushEdit(data) {
  return request({
    url: "/gsweb/domain/push/submit",
    data,
    method: "post",
    isToken: true,
  });
}

// 域名订单列表
export function orderPageList(params) {
  return request({
    url: "/gsweb/order/domain/get",
    params,
    method: "get",
    isToken: true,
  });
}

// 域名订单-取消订单
export function orderCancel(data) {
  return request({
    url: "/gsweb/order/cancel",
    params: data,
    method: "post",
    isToken: true,
  });
}

// 域名订单-订单详情
export function orderDetail(params) {
  return request({
    url: "/gsweb/order/detail",
    params,
    method: "get",
    isToken: true,
  });
}

// 设置隐私保护
export function domainSetPrivacy(data) {
  return request({
    url: `/gsweb/domain/protected`,
    data,
    method: "post",
    isToken: true,
  });
}

// 我的域名-自动续费
export function domainAutoRenew(data) {
  return request({
    url: `/gsweb/domain/renew/auto`,
    data,
    method: "post",
    isToken: true,
  });
}


// 站内信类型
export function mailSiteType() {
  return request(
    {
      url: "/gsweb/messageTemplates/siteType",
      method: "get",
      isToken: true,
    },
  );
}

// 获取站内信列表
export function mailSiteList(data) {
  return request(
    {
      url: "/gsweb/messageTemplates/siteList",
      method: "post",
      data,
      isToken: true,
    }
  );
}


// 站内信设置已读
export function mailSiteRead(data) {
  return request(
    {
      url: "/gsweb/messageTemplates/siteRead",
      method: "post",
      data,
      isToken: true,
    }
  );
}



// 删除站内信
export function mialSiteDel(data) {
  return request(
    {
      url: "/gsweb/messageTemplates/siteDel",
      method: "post",
      data,
      isToken: true,
    }
  );
}


// 例行维护公告
export function serverUpdate() {
  return request(
    {
      url: "/gsweb/content/serverUpdate",
      method: "post",
      isToken: true,
    },
  );
}


export function getWhois(params) {
  return request({
    url: "/gsweb/domain/whois",
    method: "get",
    params
  });
}

//Whois查询
export function getCaptchaWhoisV1(domain) {
  return request({
    url: `/gsweb/sys/captcha/whois/${domain}`,
    method: "get",
  });
}

//Whois查询
export function getCaptchaWhoisV2(domain, id, vCode) {
  return request({
    url: `/gsweb/sys/captcha/whois/${domain}/${id}/${vCode}`,
    method: "get",
  });
}
